import type React from 'react';
import Toast, { type ToastProps } from './Toast';

export interface ToastData {
  id: string;
  type: ToastProps['type'];
  title: string;
  message?: string;
  duration?: number;
  action?: ToastProps['action'];
  dismissible?: ToastProps['dismissible'];
}

interface ToastContainerProps {
  toasts: ToastData[];
  onRemoveToast: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemoveToast }) => {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          duration={toast.duration}
          onClose={onRemoveToast}
          action={toast.action}
          dismissible={toast.dismissible}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
